module.exports = __webpack_public_path__ + "US.png?5b98f6f3041409dd54d4684ef14a9876";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/US.png
// module id = 52
// module chunks = 0